import { Button } from '@creanizer/ui'
import { Input } from '@creanizer/ui'
import { Label } from '@creanizer/ui'
import { Plus, X } from 'lucide-react'
import type { RequiredRelationship } from '@creanizer/types'

interface RequiredRelationshipsProps {
  relationships: RequiredRelationship[]
  onChange: (relationships: RequiredRelationship[]) => void
}

export function RequiredRelationships({ relationships, onChange }: RequiredRelationshipsProps) {
  const addRelationship = () => {
    onChange([...relationships, { name: '', relationship: '' }])
  }

  const updateRelationship = (index: number, field: keyof RequiredRelationship, value: string) => {
    const updated = [...relationships]
    updated[index] = { ...updated[index], [field]: value }
    onChange(updated)
  }

  const removeRelationship = (index: number) => {
    onChange(relationships.filter((_, i) => i !== index))
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Label>必須の関係性（オプション）</Label>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={addRelationship}
        >
          <Plus className="h-4 w-4 mr-1" />
          追加
        </Button>
      </div>

      {relationships.length > 0 && (
        <div className="space-y-2">
          {relationships.map((rel, index) => (
            <div key={index} className="card p-3">
              <div className="flex items-start gap-2">
                <div className="flex-1 grid grid-cols-2 gap-2">
                  <Input
                    placeholder="キャラクター名"
                    value={rel.name}
                    onChange={(e) => updateRelationship(index, 'name', e.target.value)}
                  />
                  <Input
                    placeholder="関係性（例：幼馴染、ライバル）"
                    value={rel.relationship}
                    onChange={(e) => updateRelationship(index, 'relationship', e.target.value)}
                  />
                  <Input
                    className="col-span-2"
                    placeholder="詳細説明（オプション）"
                    value={rel.description || ''}
                    onChange={(e) => updateRelationship(index, 'description', e.target.value)}
                  />
                </div>
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  onClick={() => removeRelationship(index)}
                >
                  <X className="h-4 w-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}

      {relationships.length === 0 && (
        <p className="text-sm text-muted-foreground">
          必須の関係性を追加すると、指定したキャラクターとの関係が必ず生成されます
        </p>
      )}
    </div>
  )
}